import * as React from 'react';

export const Footer: React.FunctionComponent = () => null;
